export default __webpack_public_path__ + "2f563c3f50a1584ea8bd0178d1203537.svg";